import React, { Component } from 'react'
import WalletData from './walletData'
import Recaptcha from 'react-recaptcha'
import CommonFetch from '../../../requests/commonFetch'

export default class Confirmation extends Component {
    constructor(props) {
        super(props)

        this.state = {
            initialPage: true,
            tfaPage: false,
            loading: false,
        }

        this.translation = JSON.parse(localStorage.translation)[
            localStorage.language
        ]
    }

    render() {
        let { paymentData } = this.props
        let { fail_url, payment_id } = paymentData

        return (
            <div className="payment__box_right">
                <WalletData paymentData={this.props.paymentData} />
                {this.paymentConfirmationForm()}
                <a
                    href={`${fail_url}depositorypayment_id=${payment_id}&depositorypayment_error=decline`}
                >
                    <button className="payment__button payment__button_close">
                        {this.translation['Refuse']}
                    </button>
                </a>
            </div>
        )
    }

    paymentConfirmationForm = () => {
        let { loading } = this.state
        let { paymentState, paymentTFA } = this.props
        return (
            <form
                className="payment-form payment-form_margin-top-m"
                onSubmit={this.paymentRequest}
            >
                {paymentState === 'wait_2fa_code' ? (
                    <React.Fragment>
                        {paymentTFA ? (
                            <p className="payment__desc payment__margin-bottom_m">{`${
                                this.translation[
                                    'Two-factor authentication type'
                                ]
                            }: ${this.getCorrectTFAType(
                                this.props.paymentTFA
                            )}`}</p>
                        ) : null}
                        <div className="payment-form__group payment__margin-bottom_m">
                            <input
                                type="text"
                                name="2fa_code"
                                className="payment-form__input"
                                placeholder="TFA Code"
                                id="tfaCode"
                                autoComplete="off"
                                required
                            />
                            <label
                                htmlFor="tfaCode"
                                className="payment-form__label"
                            >
                                TFA Code
                            </label>
                        </div>
                    </React.Fragment>
                ) : (
                    this.recaptchaWrap()
                )}
                {!loading ? (
                    <input
                        className="payment__button"
                        type="submit"
                        value={
                            paymentState === 'wait_2fa_code'
                                ? this.translation['Check']
                                : this.translation['Continue']
                        }
                    />
                ) : (
                    <div className="payment__spinner">
                        <FontAwesomeIcon icon={'spinner'} />
                    </div>
                )}
            </form>
        )
    }

    changeLoadingStatus = () => {
        this.setState({
            loading: !this.state.loading,
        })
    }

    getCorrectTFAType = type => {
        switch (type) {
            case 'email':
                return 'Email'
                break
            case 'sms':
                return 'SMS'
                break
            case 'ga':
                return 'Google Authenticator'
                break
            case 'none':
                return 'None'
                break
            default:
                return 'Unknown'
                break
        }
    }

    paymentRequest = event => {
        event.preventDefault()
        let form = new FormData(event.target)
        form.append('id', this.props.paymentData.id)

        this.changeLoadingStatus()
        CommonFetch({
            path: 'ui/depository/post_payment',
            method: 'POST',
            data: form,
        }).then(data => {
            this.changeLoadingStatus()
            console.log(data)
            this.props.getPaymentInfo()
        })
    }

    recaptchaWrap = () => {
        let { captchaKey } = this.props

        if (!captchaKey) return null
        return (
            <Recaptcha
                sitekey={`${captchaKey}`}
                render="explicit"
                theme="dark"
                size="normal"
                badge="inline"
                hl={localStorage.language}
            />
        )
    }
}
